<template lang="pug">
    nav.pagination(role="navigation" aria-label="pagination" v-if="pages.length")
        a.pagination-previous(@click="goto(page-1)")
            span.icon
                i.fas.fa-backward
        a.pagination-previous(@click="goto(1)")
            span.icon
                i.fas.fa-step-backward
        a.pagination-next(@click="goto(count)")
            span.icon
                i.fas.fa-step-forward
        a.pagination-next(@click="goto(page+1)")
            span.icon
                i.fas.fa-forward
        ul.pagination-list
            li(v-for="num in pages")
                span.pagination-ellipsis(v-if="num===null") &hellip;
                a.pagination-link(v-else @click="goto(num)" :class="{ 'is-current': page === num }") {{ num }}
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 25
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    count() {
      return Math.ceil(this.total / this.perPage);
    },
    pages() {
      let pages = [];
      const count = this.count;

      if (count > 1) {
        if (count <= 5) {
          pages = [...Array(count).keys()].map(p => ++p);
        } else {
          pages = Array(7).fill(null);
          pages[0] = 1;
          pages[6] = count;

          if (this.page > count - 4) {
            for (let i = 1, end = 6; i < end - 1; i++) {
              pages[end - i] = count - i;
            }
          } else if (this.page <= 4) {
            for (let i = 1, end = 6; i < end - 1; i++) {
              pages[i] = i + 1;
            }
          } else {
            pages[2] = this.page - 1;
            pages[3] = this.page;
            pages[4] = this.page + 1;
          }
        }
      }

      return pages;
    }
  },
  watch: {
    page() {
      this.testCurrentPage();
    },
    count() {
      this.testCurrentPage();
    }
  },
  methods: {
    goto(page) {
      if (page >= 1 && page <= this.count && page !== this.page)
        this.$emit("click", page);
    },
    testCurrentPage() {
      if (this.page > this.count) this.goto(1);
    }
  },
  mounted() {
    this.testCurrentPage();
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  margin: 2rem 0;

  a {
    color: $defaultColor;
  }

  .pagination-link,
  .pagination-previous,
  .pagination-next {
    padding: 0.5rem;
    border: none;
    background-color: $cardFontColor;
    transition: all 0.2s linear;

    &.is-current {
      opacity: 0.6;
      cursor: default;
    }

    &:hover {
      background-color: darken($cardFontColor, 5%);
    }
  }

  .pagination-ellipsis {
    padding: 0 0.1rem;
  }
}
</style>
